"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.getSources = void 0;

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.is-array");

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactProptypeConditionalRequire = _interopRequireDefault(require("react-proptype-conditional-require"));

var _Wrapper = _interopRequireDefault(require("./Wrapper"));

var _ImageContainer = _interopRequireDefault(require("./ImageContainer"));

var _Picture = _interopRequireDefault(require("./Picture"));

var _imageModule = _interopRequireDefault(require("./image.module.less"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types -- directive added automatically by Shepherd migration
var getSources = function getSources(props) {
  return (props.sources || []).length ? props.sources : [props];
};

exports.getSources = getSources;

var isSizeDerivable = function isSizeDerivable(props) {
  return !props.expandToContent && props.sources.length <= 1;
};

var Image = function Image(props) {
  var src = props.src,
      srcSet = props.srcSet,
      naturalHeight = props.naturalHeight,
      naturalWidth = props.naturalWidth,
      className = props.className,
      backgroundColor = props.backgroundColor,
      children = props.children,
      expandToContent = props.expandToContent,
      lazy = props.lazy,
      offset = props.offset,
      overflow = props.overflow,
      alt = props.alt,
      imageClassName = props.imageClassName,
      objectFit = props.objectFit,
      objectPosition = props.objectPosition,
      placeholderImage = props.placeholderImage,
      title = props.title,
      caption = props.caption;

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isLoaded = _React$useState2[0],
      setIsLoaded = _React$useState2[1];

  var _React$useState3 = _react["default"].useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      error = _React$useState4[0],
      setError = _React$useState4[1];

  _react["default"].useEffect(function () {
    // Since we have server side rendering, client side error events could occur
    // prior to React initialization on the client side. Create a custom image component
    // on client side render to check for errors.
    // https://discuss.reactjs.org/t/onerror-for-img-to-hide-images-with-error/2094/12
    var imgLoader = new window.Image();

    imgLoader.onerror = function () {
      setIsLoaded(false);
      setError(true);
    };

    if (src) {
      imgLoader.src = src;
    }

    if (srcSet) {
      imgLoader.srcset = srcSet;
    }
  }, // eslint-disable-next-line react-hooks/exhaustive-deps -- directive added automatically by Shepherd migration
  []);

  var onLoad = _react["default"].useCallback(function () {
    if (isLoaded) {
      setIsLoaded(true);
    }
  }, [isLoaded]); // Check for natural height / natural width existence first so we don't do math with an unexpected value


  var aspectRatioPercentage = naturalHeight && naturalWidth ? naturalHeight * 100.0 / naturalWidth : 0;
  var sources = getSources(props);
  var aspectRatio = props.aspectRatio;
  return /*#__PURE__*/_react["default"].createElement("figure", {
    className: (0, _classnames["default"])(_imageModule["default"].figure, className)
  }, /*#__PURE__*/_react["default"].createElement(_Wrapper["default"], {
    backgroundColor: backgroundColor,
    placeholderImage: placeholderImage // Apply outer aspect ratio classes
    ,
    className: aspectRatio ? (0, _classnames["default"])(_imageModule["default"]['aspect-ratio']) : null,
    aspectRatio: aspectRatio
  }, /*#__PURE__*/_react["default"].createElement(_ImageContainer["default"], {
    aspectRatioPercentage: aspectRatioPercentage // Apply container aspect ratio
    ,
    hasAspectRatio: !!aspectRatio,
    content: children,
    expandToContent: expandToContent,
    lazy: lazy,
    loaded: isLoaded,
    offset: offset,
    overflow: overflow,
    sources: sources
  }, /*#__PURE__*/_react["default"].createElement(_Picture["default"], {
    alt: alt,
    className: (0, _classnames["default"])(imageClassName, // Apply the correct class on the underlying
    // img element as well if aspectRatio provided
    aspectRatio && _imageModule["default"]['aspect-ratio-image']),
    error: error,
    expandToContent: expandToContent,
    objectFit: objectFit,
    objectPosition: objectPosition,
    onLoad: onLoad,
    placeholderImage: placeholderImage,
    sources: sources,
    src: src,
    srcSet: srcSet,
    title: title
  }))), caption && /*#__PURE__*/_react["default"].createElement("figcaption", {
    className: _imageModule["default"].figcaption
  }, caption));
};

Image.displayName = 'Image';
Image.propTypes = {
  alt: _propTypes["default"].string.isRequired,

  /**
   * This is a prop to restrict the image
   * to the standard NerdWallet-supported
   * aspect ratios. Some common ratios might
   * be '1:1', '5:2', or '13:8'.
   */
  aspectRatio: _propTypes["default"].string,
  backgroundColor: _propTypes["default"].string,
  caption: _propTypes["default"].node,
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  expandToContent: _propTypes["default"].bool,
  imageClassName: _propTypes["default"].string,
  lazy: _propTypes["default"].bool,
  media: _propTypes["default"].string,
  // eslint-disable-line react/no-unused-prop-types
  naturalHeight: (0, _reactProptypeConditionalRequire["default"])(_propTypes["default"].number, isSizeDerivable),
  naturalWidth: (0, _reactProptypeConditionalRequire["default"])(_propTypes["default"].number, isSizeDerivable),
  objectFit: _propTypes["default"].string,
  objectPosition: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  offset: _propTypes["default"].number,
  overflow: _propTypes["default"].bool,
  placeholderImage: _propTypes["default"].string,
  src: _propTypes["default"].string.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  sources: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    media: _propTypes["default"].string,
    srcSet: _propTypes["default"].string,
    sizes: _propTypes["default"].string
  })),
  srcSet: _propTypes["default"].string,
  title: _propTypes["default"].string
};
Image.defaultProps = {
  aspectRatio: null,
  lazy: false,
  offset: 100,
  sources: []
};
var _default = Image;
exports["default"] = _default;